import { FormState } from '../../models';
import { basicInfo } from './basic-info';
import { dataDelivery } from './data-delivery';
import { configureAlarms } from './alarms';
import { foreSiteXDInfo } from './foresite-xd-sensor';
import { foreSiteRadarSensor } from './sensors/radar-sensor';
import { dialogActions } from './dialog-actions';
import { ForesiteXDLocationCardState } from './models';
/**
 * Foresite form configuration
 */
export const foresiteXDFormState = (state: ForesiteXDLocationCardState): FormState => {
    return {
        config: {
            info: {
                id: 'foresite-location-config',
                title: 'Foresite Location Configuration',
            },
            sections: [
                basicInfo(state),
                foreSiteXDInfo,
                foreSiteRadarSensor(state),
                configureAlarms(state),
                dataDelivery(state),
                dialogActions(state),
            ],
        },
        pristine: true,
        valid: false,
        submitted: false,
    };

}
